/**
 * @file Component to assemble components for showing a selected entity for editing.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from '../../core/dialog.service';
import { AlertsService } from '../../core/alerts.service';
import { DomainService } from '../../domain.service';
import { DetailBase } from '../../base/detail/detail.base';
import { UserService } from '../../user.service';
import { SettingsService } from '../../settings.service';
/**
 * The detail component shows one entity.
 */
var DetailComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DetailComponent, _super);
    /**
     * Constructs a DetailComponent
     * @param configurationsService Service to get the configuration for this component.
     * @param router The angular router enabling navigation between the different form modes.
     * @param route The active route.
     * @param dialogService The dialog service.
     * @param alertsService The alert service.
     * @param translateService The translation service.
     */
    function DetailComponent(userService, router, route, breezeService, dialogService, alertsService, settingsService, translateService) {
        var _this = _super.call(this, userService, router, route, breezeService, dialogService, alertsService, settingsService, translateService) || this;
        _this.route = route;
        _this.breezeService = breezeService;
        _this.dialogService = dialogService;
        _this.alertsService = alertsService;
        return _this;
    }
    /**
     * Actions are only allowed when the current user is the owner of the shown entity.
     * The method checks also if actions are defined in the configuration.
     * @param {Entity} item The entity shown.
     * @returns {boolean} True when the user is the owner of the shown entity otherwise false.
     */
    DetailComponent.prototype.actionsAllowed = function (item) {
        if (!_super.prototype.actionsAllowed.call(this, item)) {
            return false;
        }
        var entity = item;
        // Demands and services have to be allowed for the accept buttons on the marketplace.
        // Tasks, shift and their templates have to be allowed for the copy buttons.
        if (entity.entityType.shortName === 'Demand' || entity.entityType.shortName === 'Service' ||
            entity.entityType.shortName === 'Task' || entity.entityType.shortName === 'TaskTemplate' ||
            entity.entityType.shortName === 'Shift' || entity.entityType.shortName === 'ShiftTemplate' ||
            entity.entityType.shortName === 'Function') {
            return true;
        }
        // Actions directly on entities are always allowed (only User.enable so far)
        if (this.configuration.actions.some(function (action) { return action.method != null; })) {
            return true;
        }
        if (entity.entityType.shortName === 'PlanItem') {
            entity = entity['Item'];
        }
        var resourceOid = entity['Resource_Oid'];
        if (!resourceOid) {
            return false;
        }
        if (this.userService.resourceOid !== resourceOid) {
            return false;
        }
        return true;
    };
    return DetailComponent;
}(DetailBase));
export { DetailComponent };
